import axios from "axios";
import { unAuthApi, unAuthPath } from "@/utils/base";
import store from "@/stores";
import { getAuthTokenValue, removeAuthToken } from "@kaihong/utils/lib/khAuthToken";
import { goLogin } from "@/utils";

type serviceConfigType = {
  baseURL: string;
  timeout: number;
  withCredentials: boolean;
  headers: any;
};

// 未登录状态码
const NOT_LOGIN_STATES: number[] = [401];

/**
 * 判断是否登录
 * @param status 状态
 * @returns
 */
const hasLogin = (status: number, config?: any) => {
  if (config) {
    // 先判断接口是否要登录
    const isUnAuth = unAuthApi.some((item) => config.url.includes(item));
    if (isUnAuth) {
      if (NOT_LOGIN_STATES.indexOf(status) > -1) {
        removeAuthToken("Authorization");
        removeAuthToken("X-Access-Token");
        store.dispatch({
          type: "setPortalAuthorization",
          payload: "",
        });
      }
      return true;
    } else {
      if (NOT_LOGIN_STATES.indexOf(status) > -1) {
        // 未登录
        goLogin();
        return false;
      } else {
        return true;
      }
    }
  }
  // 再判断当前页面是否需要登录
  const pathname = window.location.pathname;
  // if (isPathAllowed(pathname, unAuthPath)) {
  if (unAuthPath.some((path) => pathname === path)) {
    if (NOT_LOGIN_STATES.indexOf(status) > -1) {
      removeAuthToken("Authorization");
      removeAuthToken("X-Access-Token");
      store.dispatch({
        type: "setPortalAuthorization",
        payload: "",
      });
    }
    return true;
  } else {
    if (NOT_LOGIN_STATES.indexOf(status) > -1) {
      // 未登录
      goLogin();
      return false;
    } else {
      return true;
    }
  }
};

// 请求配置处理
const serviceConfig: serviceConfigType = {
  baseURL: "",
  timeout: 30 * 1000, // 超时时间
  withCredentials: true, // 表示跨域请求时是否需要使用凭证
  headers: {}, // 自定义请求头
};

const service = axios.create(serviceConfig);

service.interceptors.request.use((config: any) => {
  if (config.url.includes("/app/upload/public/")) {
    delete config.timeout;
  }
  // 不需要登录的接口要把headers里Authorization去掉
  const isUnAuth = unAuthApi.some((item) => config.url.includes(item));
  if (isUnAuth) {
    delete config.headers.Authorization;
  } else {
    // 给请求增加自定义请求头，将Authorization放到请求头
    if (!config.headers.Authorization) {
      config.headers.Authorization = getAuthTokenValue("Authorization") || "";
    }
  }
  return config;
});

service.interceptors.response.use(
  async (res: any) => {
    const { data } = res;

    if (!hasLogin(data?.code)) {
      return data;
    }
    // 文件下载错误信息处理
    if (res.config.responseType === "blob" && res.headers["content-type"].indexOf("application/json") !== -1) {
      const blodData = await new Response(data).text();
      return JSON.parse(blodData);
    }

    return data;
  },
  (err: any) => {
    const {
      response: { status, config },
    } = err;
    if (!hasLogin(status, config)) {
      return;
    }
    return Promise.reject(err);
  }
);

export default service;
